import styled from 'styled-components';

export const Loading = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 998;

  & > p {
    top: 50%;
    left: 50%;
    position: fixed;
    margin-top: 30px;
    margin-left: -50px;
    color: red;
    font-weight: bold;
  }
`;
